import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radioStatus', 'radioLabel', 'meetingSlot']

  handleSelection() {
    this.radioLabelTargets.forEach((label, index) => {
      if (this.radioStatusTargets[index].checked) {
        label.firstElementChild.classList.remove('hidden')
      } else {
        label.firstElementChild.classList.add('hidden')
      }
    })
  }

  toggleMeetingSlot(e) {
    const selectedValue = e.target.value
    this.meetingSlotTarget.classList.toggle('hidden', selectedValue !== 'true')
  }
}
